import React from 'react';
import styled from 'styled-components';

import { v4 as uuidv4 } from 'uuid';
import { AIToolEvent } from '../../tool.types';
import { Stack } from '@mui/material';
import { Label } from '@common/Label';
import { Button } from '@common/Button';
import { SettingToolEvent } from './SettingToolEvent';
import { NodeAIArgument } from '@components/Flow/Nodes';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: 0.75rem;
`;

interface Props {
  toolEvents: AIToolEvent[];
  setToolEvents: React.Dispatch<React.SetStateAction<AIToolEvent[]>>;
  toolArguments: NodeAIArgument[];
}

export const SettingToolEvents: React.FC<Props> = ({ toolEvents, setToolEvents, toolArguments }) => {
  const addToolEvent = () => {
    setToolEvents((prevState) =>
      prevState.concat({
        id: uuidv4(),
        type: '',
        value: '',
        trigger: 'after_execution',
      })
    );
  };

  return (
    <Container>
      <Stack spacing={1}>
        <Label
          title='Tool Events'
          tooltip='Define events that will be sent when this tool is finished executing. If using HTTP requests, the events will be defined in the metadata of the final response. If using streaming, the events will be sent as soon as the tool is finished executing.'
        />
        {toolEvents.map((event) => (
          <SettingToolEvent
            key={event.id}
            toolEvent={event}
            setToolEvents={setToolEvents}
            toolArguments={toolArguments}
          />
        ))}
      </Stack>
      <Button customColor='black' fullWidth onClick={addToolEvent}>
        Add Event
      </Button>
    </Container>
  );
};
